import { Instance } from 'mobx-state-tree';
import { RouteDeletedDtoModelBase } from './RouteDeletedDtoModel.base';

/* The TypeScript type of an instance of RouteDeletedDtoModel */
export interface RouteDeletedDtoModelType extends Instance<typeof RouteDeletedDtoModel.Type> {}

/* A graphql query fragment builders for RouteDeletedDtoModel */
export { selectFromRouteDeletedDto, routeDeletedDtoModelPrimitives, RouteDeletedDtoModelSelector } from './RouteDeletedDtoModel.base';

/**
 * RouteDeletedDtoModel
 *
 * Route deleted event
 */
export const RouteDeletedDtoModel = RouteDeletedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
